import './Body.scss';

import { cva, VariantProps } from 'class-variance-authority';
import classNames from 'classnames';
import { FC, PropsWithChildren } from 'react';

const baseClassName = 'ds-Body';

const bodyVariance = cva(baseClassName, {
  variants: {
    accent: {
      text: `${baseClassName}--accent-text`,
      title: `${baseClassName}--accent-title`,
    },
    size: {
      10: `${baseClassName}--size-10`,
      14: `${baseClassName}--size-14`,
      16: `${baseClassName}--size-16`,
      24: `${baseClassName}--size-24`,
    },
    weight: {
      '600': `${baseClassName}--weight-600`,
      '800': `${baseClassName}--weight-800`,
    },
    color: {
      white: `${baseClassName}--color-white`,
      'support-yellow-6': `${baseClassName}--colors-support-yellow-6`,
    },
    strikethrough: {
      true: `${baseClassName}--strikethrough`,
    },
  },
  defaultVariants: {
    accent: 'text',
    size: 16,
  },
});

type BodyProps = {
  className?: string;
  as?: 'div' | 'p' | 'span';
} & VariantProps<typeof bodyVariance>;

export const Body: FC<PropsWithChildren<BodyProps>> = ({
  accent = 'text',
  size = 16,
  weight,
  className,
  children,
  color = undefined,
  as = 'span',
  strikethrough = false,
}) => {
  const Tag = as;

  return (
    <Tag
      className={classNames(
        bodyVariance({ accent, size, weight, color, strikethrough }),
        className,
      )}
    >
      {children}
    </Tag>
  );
};

export default Body;
